/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-len */
import React, { useState, useEffect } from "react";
import { Button, Col, Form, Input, Row, Space } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import Heading from "components/Common/Heading/Heading";
import { ResetPasswordData, ResetPasswordFormValues } from "interfaces/ApiInterface/ILoginFormData";
import { resetPassword } from "api/services/userAuth.api";
import { notificationController } from "components/Common/Notification/Notification";
import { useAppSelector } from "hooks/reduxHooks";
import { ROUTES_PATH } from "routes/Routes.Constant";

const ResetPassword: React.FC = () => {
  const [form] = Form.useForm<ResetPasswordFormValues>();
  const [isLoading, setLoading] = useState(false);
  const [tokenData, setTokenData] = useState({ passwordToken: "", userName: "" });
  const location = useLocation();
  const navigate = useNavigate();
  const localPortalData: any = useAppSelector((state) => state.landingPage.lockerPortalDetails);

  useEffect(() => {
    const query = location.search.substring(1);
    const params = query.split("&").reduce((acc, current) => {
      const [key, value] = current.split("=");
      acc[key] = decodeURIComponent(value);
      return acc;
    }, {} as any);

    setTokenData({
      passwordToken: params?.passwordToken,
      userName: params?.userName,
    });
  }, [location]);

  const handleSubmit = async (values: ResetPasswordFormValues) => {
    const portalId = localPortalData?.lockerPortalDetails?.PortalId || null;
    setLoading(true);

    const data: ResetPasswordData = {
      PortalId: portalId,
      User: {
        UserName: tokenData?.userName,
        PasswordToken: tokenData?.passwordToken,
        NewPassword: values?.newPassword,
      },
    };

    resetPassword(data)
      .then(() => {
        notificationController.success({
          message: "Password successfully reset.",
        });
        navigate(ROUTES_PATH.LOGIN);
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.ErrorMessage || "An unexpected error occurred.";
        notificationController.error({
          message: errorMessage,
        });
        setLoading(false);
      });
  };

  return (
    <div className="page-content-wrapper p-30">
      <Row gutter={15} className="profile-form-container">
        <Col span={12} xs={24} md={12} lg={12} xxl={12}>
          <Heading titleText="Reset Password" titleClass="profile-heading" />
          <div className="form-wrapper">
            <Form
              form={form}
              layout="vertical"
              name="resetPassword"
              onFinish={handleSubmit}
              autoComplete="off"
            >
              <Form.Item
                label={
                  <span className="wrapper">
                    New Password <span className="text-danger">*</span>
                  </span>
                }
                name="newPassword"
                rules={[
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(new Error("This field cannot be left blank."));
                      }
                      if (
                        (value && value.length < 6) ||
                        !/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*(),.?":{}|<>]{8,}$/.test(
                          value
                        )
                      ) {
                        return Promise.reject(
                          new Error(
                            "Password must be at least 8 alphanumeric characters and contain at least one number."
                          )
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                className="input-label"
              >
                <Input.Password className="form-input" />
              </Form.Item>

              <Form.Item
                label={
                  <span className="wrapper">
                    Confirm New Password <span className="text-danger">*</span>
                  </span>
                }
                name="confirm"
                dependencies={["newPassword"]}
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(new Error("This field cannot be left blank."));
                      }
                      if (
                        value.length < 8 ||
                        !/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*(),.?":{}|<>]{8,}$/.test(
                          value
                        )
                      ) {
                        return Promise.reject(
                          new Error(
                            "Password must be at least 8 alphanumeric characters and contain at least one number."
                          )
                        );
                      }
                      if (!value || getFieldValue("newPassword") !== value) {
                        return Promise.reject(
                          new Error("The two passwords that you entered do not match.")
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                className="input-label"
              >
                <Input.Password className="form-input" />
              </Form.Item>

              <Form.Item className="profile-action">
                <Space size={"middle"}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    className={isLoading ? "btn-disabled profile-btn" : "profile-btn"}
                  >
                    Reset Password
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ResetPassword;